import { registerFilters } from 'core/components'

registerFilters('internalUsersGet', {
  userType: {
    type: 'enum',
    enum: ['borrower', 'agent', 'service'],
    label: 'User type',
  },
  limit: {
    type: 'integer',
    label: 'Page size',
    placeholder: '50',
  },
})
